import { render } from "./LeaveRequestModal.vue?vue&type=template&id=72b406fa&scoped=true"
import script from "./LeaveRequestModal.vue?vue&type=script&lang=js"
export * from "./LeaveRequestModal.vue?vue&type=script&lang=js"

import "./LeaveRequestModal.vue?vue&type=style&index=0&id=72b406fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b406fa"]])

export default __exports__